require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-mongodb-and-mongoose-create-a-model.json") })
        }
      }, "path---apis-and-microservices-mongodb-and-mongoose-create-a-model");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-mongodb-and-mongoose-create-a-model!./.cache/json/apis-and-microservices-mongodb-and-mongoose-create-a-model.json
// module id = 1278
// module chunks = 231608221292675